"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var useScrollTracker_1 = require("./useScrollTracker");

exports.useScrollTracker = useScrollTracker_1.default;